const API_BASE = "https://app.techdroid.ca";

export const APP_NAME = "PinMyDoc";

export const BRAND = {
  primaryBlue: "#1A6FE8",
  deepBlue: "#1255C0",
  softBlue: "#E8F1FD",
  accentGreen: "#00C48C",
  alertRed: "#E8294A",
  darkNavy: "#0D1B2A",
  offWhite: "#F7F9FC",
  border: "#E2E8F0",
};

export const DISCLAIMER =
  "Doctor availability may change. Information shown is based on public sources and community reports. Please confirm directly with the clinic.";

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, options);

  let data = null;

  try {
    data = await response.json();
  } catch (error) {
    throw new Error("Server returned an unreadable response");
  }

  if (!response.ok) {
    throw new Error(data?.detail || data?.message || "Server error");
  }

  return data;
}

function getAdminHeaders() {
  return {
    "Content-Type": "application/json",
    "X-Admin-Token": localStorage.getItem("admin-auth") || "",
  };
}

function getAdminUploadHeaders() {
  return {
    "X-Admin-Token": localStorage.getItem("admin-auth") || "",
  };
}

export function fetchDoctors(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/doctors.php${query ? `?${query}` : ""}`);
}

export function fetchDoctor(id) {
  return request(`/doctor.php?id=${encodeURIComponent(id)}`);
}

export function fetchMetadata() {
  return request("/metadata.php");
}

export function submitReport(data) {
  return request("/report.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export function addDoctor(data) {
  return request("/admin_add_doctor.php", {
    method: "POST",
    headers: getAdminHeaders(),
    body: JSON.stringify(data),
  });
}

export function deleteDoctor(id) {
  return request("/admin_delete_doctor.php", {
    method: "POST",
    headers: getAdminHeaders(),
    body: JSON.stringify({ id }),
  });
}

export function updateDoctor(data) {
  return request("/admin_update_doctor.php", {
    method: "POST",
    headers: getAdminHeaders(),
    body: JSON.stringify(data),
  });
}

export function fetchReports() {
  return request("/admin_reports.php", {
    method: "GET",
    headers: getAdminHeaders(),
  });
}

export function moderateReport(reportId, action) {
  return request("/admin_moderate_report.php", {
    method: "POST",
    headers: getAdminHeaders(),
    body: JSON.stringify({
      report_id: reportId,
      action,
    }),
  });
}

export function importDoctorsCsv(file) {
  const formData = new FormData();
  formData.append("csv", file);

  return request("/admin_import_doctors.php", {
    method: "POST",
    headers: getAdminUploadHeaders(),
    body: formData,
  });
}

export function fetchLaunchChecklist() {
  return request("/admin_launch_checklist.php", {
    method: "GET",
    headers: getAdminHeaders(),
  });
}

export function updateLaunchChecklist(itemKey, isChecked, checkedBy = "admin") {
  return request("/admin_update_launch_checklist.php", {
    method: "POST",
    headers: getAdminHeaders(),
    body: JSON.stringify({
      item_key: itemKey,
      is_checked: isChecked ? 1 : 0,
      checked_by: checkedBy,
    }),
  });
}